<template>
  <div>
    <v-card class="mb-5 elevation-0">
      <v-container>
        <v-btn elevation="0" color="primary">일괄결재</v-btn>
      </v-container>
    </v-card>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      item-key="cashDsbrVchNo"
      show-select
      @click:row="handleClick"
    >
      <!-- <template v-slot:[`item.title`]="{ item }">
        <router-link to="/approval/view">{{ item.title }}</router-link>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import SetComma from "@/mixins/SetComma";
import { listDsbr } from "@/api/approval";

export default {
  // 기준년월
  data() {
    return {
      selected: [],
      headers: [
        {
          text: "귀속년월",
          value: "imptYm",
          // width: "8%",
        },
        {
          text: "작성일",
          value: "wrDt",
          // width: "8%",
        },
        {
          text: "부서",
          value: "deptNm",
          // width: "8%",
        },
        {
          text: "작성자",
          value: "empNm",
          // width: "8%",
        },
        {
          text: "금액",
          value: "sumAmt",
          sortable: false,
          // width: "8%",
        },
        {
          text: "결재상태",
          value: "signPrgsNm",
          // width: "8%",
        },
        {
          text: "최종상태변경일",
          value: "payDt",
          // width: "8%",
        },
        {
          text: "최종상태 결재 의견",
          value: "note",
          sortable: false,
          // width: "8%",
        },
      ],
      items: [],
    };
  },
  mixins: [SetComma],
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      try {
        const { data } = await listDsbr();
        const newData = data.list.map(v => {
          let payDt = v.payDt || "";
          payDt = payDt.toString();
          let wrDt = v.payDt || "";
          wrDt = wrDt.toString();

          v.sumAmt = `￦${this.comma(v.sumAmt)}`;
          v.payDt = payDt === "" ? "" : moment(payDt).format("YYYY-MM-DD");
          v.wrDt = wrDt === "" ? "" : moment(wrDt).format("YYYY-MM-DD");
          return v;
        });
        this.items = newData;
      } catch (error) {
        console.log(error);
      }
    },
    handleClick(item) {
      this.$router.push(`/approval/view/${item.cashDsbrVchNo}`);
    },
  },
};
</script>

<style></style>
